import React from "react";
import { useTranslation } from "react-i18next";
import { useEditTask } from "@planzone/view-models";
import { Props } from "./types";
import styles from "./styles.scss";
import classNames from "classnames";

function NameForm({ task, isInvalid, hide }: Props) {
  const { t } = useTranslation();
  const [name, setName] = React.useState(task.name);
  const { isRequestPending, editTask } = useEditTask(task);
  const submit = () => {
    !isRequestPending &&
      editTask({
        task,
        nextTask: {
          ...task,
          name,
        },
      });
    hide();
  };

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        submit();
      }}
    >
      <input
        className={classNames(styles.input, {
          [styles.invalid]: isInvalid,
        })}
        placeholder={t("taskForm.name")}
        value={name}
        onChange={({ target }) => setName(target.value)}
        onBlur={submit}
        autoFocus
      />
    </form>
  );
}

export { NameForm };
